import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSiteContent } from '../content/SiteContentProvider';
import NewsCard from './NewsCard';
import { getPublishedNews } from '../utils/news';

export default function SiteNews() {
  const { content } = useSiteContent();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const publishedItems = getPublishedNews(content.news.items);
  const items = publishedItems.slice(0, 3);

  if (items.length === 0) {
    return null;
  }

  return (
    <section
      className={`relative w-full py-32 px-6 lg:px-12 overflow-hidden z-20 ${isHome ? '-mt-[5vw]' : 'rounded-t-[2rem] sm:rounded-t-[2.5rem]'}`}
      style={
        isHome
          ? {
              clipPath: 'polygon(0 5vw, 100% 0, 100% calc(100% - 5vw), 0 100%)',
              background: 'linear-gradient(135deg, #ffd700 0%, #f8b900 100%)',
            }
          : {
              backgroundColor: '#facc15',
            }
      }
    >
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none">
        <div className="ambient-breathe absolute -left-24 top-24 text-[18vw] font-black leading-none text-[#1a1b24] whitespace-nowrap">
          ACTUS
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto mb-16">
          {content.news.eyebrow && (
            <p className="mb-4 text-xs font-black uppercase tracking-[0.22em] text-[#1a1b24]">
              {content.news.eyebrow}
            </p>
          )}
          <h2 className="text-3xl md:text-5xl font-black text-[#1a1b24] uppercase tracking-tighter mb-6 relative inline-block">
            {content.news.title}
          </h2>
          <p className="text-[#1a1b24] text-sm md:text-base font-medium opacity-80 leading-relaxed px-4">
            {content.news.subtitle}
          </p>
        </div>

        <div className={`grid gap-8 lg:gap-10 max-w-7xl mx-auto ${
          items.length === 1
            ? 'grid-cols-1 place-items-center'
            : items.length === 2
            ? 'grid-cols-1 md:grid-cols-2'
            : 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3'
        }`}>
          {items.map((item) => (
            <div key={item.id} className={items.length === 1 ? 'w-full max-w-sm' : 'w-full'}>
              <NewsCard item={item} />
            </div>
          ))}
        </div>

        {publishedItems.length > 3 && (
          <div className="mt-16 flex justify-center">
            <Link
              to="/actualites"
              className="bg-[#1a1b24] hover:bg-black text-white font-extrabold text-sm px-8 py-4 flex items-center justify-center border-2 border-[#1a1b24] rounded-full gap-3 transition-colors shadow-sm uppercase tracking-wide"
            >
              Voir toutes les actualités
              <ArrowRight size={18} strokeWidth={3} />
            </Link>
          </div>
        )}

        {publishedItems.length <= 3 && (
          <div className="mt-16 flex justify-center">
          <Link
            to="/actualites"
            className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-300 hover:to-orange-400 text-[#1a1b24] font-extrabold text-sm px-8 py-4 flex items-center justify-center border-2 border-[#1a1b24] rounded-full transition-colors shadow-sm uppercase tracking-wide"
          >
            AGENDA DES ÉVÉNEMENTS
          </Link>
          </div>
        )}
      </div>
    </section>
  );
}
